<template>
  <v-container fluid class="pa-0">
    <div class="aggregation-correction-report-container px-3 mb-10">
      <report-condition
        :searchCondition.sync="searchCondition"
        @updateDataChart="updateDataChart"
        :displaySourceItems="AGGREGATION_CORRECTION_DISPLAY_ITEM_VALUES"
      />
      <!-- CHART -->
      <fieldset class="zone-block pa-3 my-2 mw-900">
        <v-row>
          <div class="pre-title my-4 ml-3">
            <span>{{ $t("label.dataGraph") }}</span>
          </div>
        </v-row>
        <v-col cols="12" class="text-center" style="margin: auto">
          <v-btn
            fab
            dark
            class="elevation-0"
            style="cursor: auto"
            large
            color="secondary"
          >
            <v-icon large class="white--text">{{
              $t("ic.mdiBarChart")
            }}</v-icon>
          </v-btn>
        </v-col>
      </fieldset>

      <!-- DATA TABLE -->
      <fieldset class="zone-block pa-3 my-2 m-w-800">
        <v-row>
          <div class="pre-title my-4 ml-3">
            <span>{{ $t("label.dataTable") }}</span>
          </div>
        </v-row>
        <v-row
          v-if="displayCharts.length > 0"
          :key="aggCKey"
          style="min-width: 1200px; overflow: auto"
        >
          <aggregation-correction-report-tbl
            :request.sync="searchCondition"
            :selectedDate="selectedDate"
            :tblTypeId="REPORT_4_TBL_TYPE.BEFORE.id"
            :pagination="pagination"
            :reportLayout.sync="reportLayout"
            :tblClassColor="'primary-tbl'"
          />

          <aggregation-correction-report-tbl
            :request.sync="searchCondition"
            :selectedDate="selectedDate"
            :tblTypeId="REPORT_4_TBL_TYPE.AFTER.id"
            :pagination="pagination"
            :tblClassColor="'warning-tbl'"
            :reportLayout.sync="reportLayout"
          />

          <aggregation-correction-report-tbl
            :request.sync="searchCondition"
            :selectedDate="selectedDate"
            :tblTypeId="REPORT_4_TBL_TYPE.AFTER.id"
            :pagination="pagination"
            :tblClassColor="'success-tbl'"
            :reportLayout.sync="reportLayout"
          />
        </v-row>
        <v-row v-else>
          <v-col cols="12" class="text-center" style="margin: auto">
            <v-btn
              fab
              dark
              class="elevation-0"
              style="cursor: auto"
              large
              color="secondary"
            >
              <v-icon large class="white--text">{{
                $t("ic.mdiBarChart")
              }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </fieldset>
    </div>
  </v-container>
</template>

<script>
import { SET_LOADING, SET_PAGE_HEADER } from "@/store/mutations.type";
import ReportCondition from "@/components/report/ReportCondition";
import AggregationCorrectionReportTbl from "@/components/report/AggregationCorrectionReportTbl.vue";
import { SCREEN_TITLES } from "@/common/report.constant.js";
import { SCREEN } from "@/common/auth.const";
import { ALERT } from "@/common/utilities";
import {
  AGGREGATION_CORRECTION_DISPLAY_ITEM_VALUES,
  REPORT_4_TBL_TYPE,
  fakeData,
} from "@/common/constant";

export default {
  name: "AggregationCorrectionReport",
  components: {
    ReportCondition,
    AggregationCorrectionReportTbl,
  },
  data() {
    return {
      searchCondition: {
        referenceStartDate: null,
        referenceEndDate: null,
        compareStartDate: null,
        compareEndDate: null,
        storeCode: null,
        majorCodes: [],
        middleCodes: [],
        displayItems: [],
      },
      selectedDate: {
        referenceDate: "",
        compareDate: "",
      },
      pagination: {
        page: 1,
        itemsPerPage: 10,
        pageStart: 0,
        pageStop: 0,
        pageCount: 0,
        itemsLength: 0,
      },
      reportLayout: {
        reportIds: [],
        dataSeriesTbl: [],
      },
      aggCKey: 0,
      displayCharts: [],
      AGGREGATION_CORRECTION_DISPLAY_ITEM_VALUES:
        AGGREGATION_CORRECTION_DISPLAY_ITEM_VALUES,
      REPORT_4_TBL_TYPE: REPORT_4_TBL_TYPE,
      fakeData: fakeData,
    };
  },
  methods: {
    updateDataChart() {
      this.displayCharts.push(1);
      let data = fakeData;

      this.updateReportLayout();
    },
    updateReportLayout() {
      this.reportLayout.dataSeriesTbl = [];
      this.reportLayout.reportIds = [...this.searchCondition.displayItems];
      this.reportLayout.reportIds = this.reportLayout.reportIds.sort(
        (a, b) => a - b,
      );
      let firstAggRow = fakeData.tableByMajorResponses[0];
      let secondAggRow = fakeData.tableByMajorResponses[1];
      secondAggRow.isRowBelow = true;
      let secondHeaderRow = {
        majorCode: "大分類",
        middleCode: "中分類",
      };

      this.reportLayout.dataSeriesTbl = [
        firstAggRow,
        secondAggRow,
        secondHeaderRow,
        ...fakeData.tableByMajorResponses,
      ];
      this.aggCKey += 1;
    },
    back() {
      this.$router.push({
        name: SCREEN.HOME.NAME,
      });
    },
  },
  created() {
    this.$store.commit(SET_PAGE_HEADER, [
      SCREEN_TITLES.AGGREGATION_CORRECTION_REPORT,
      SCREEN.HOME.NAME,
      this.$t("button.back"),
      null,
      this.back,
    ]);
  },
};
</script>

<style lang="scss">
.aggregation-correction-report-container {
  height: 100%;
  .btn-change-slice:hover {
    transform: scale(1.25);
  }
  .b-1-g {
    border-right: 1px solid #d9dedb !important;
  }
}
</style>
